import React from 'react';
import { Link } from 'react-router-dom';
import BlogArticleLayout, { blogStyles as s } from './BlogArticleLayout';

function BlogArticleAttaquesSystemesIA() {
  return (
    <BlogArticleLayout
      tag="IA & Cybersécurité"
      title="Attaques contre les systèmes d'IA : ce qu'il faut savoir"
      date="1 décembre 2026"
      ctaTitle="Intégrez ces menaces à votre analyse de risques"
      ctaText="Le diagnostic aide votre équipe technique à situer son niveau d'exposition face à ces menaces spécifiques."
    >
      <p style={s.intro}>
        Un système d'IA peut être la cible d'attaques classiques, comme n'importe quel système informatique,
        mais aussi de méthodes qui exploitent spécifiquement son fonctionnement. Voici les principales à
        connaître pour un DSI ou un RSSI.
      </p>

      <h2 style={s.h2}>L'empoisonnement des données (data poisoning)</h2>
      <p>
        Cette attaque consiste à corrompre les données utilisées pour entraîner ou ajuster un modèle, afin
        d'en dégrader le comportement ou d'y introduire un biais exploitable. Elle vise la phase
        d'entraînement, en amont de toute mise en production.
      </p>

      <h2 style={s.h2}>L'extraction de modèle</h2>
      <p>
        En interrogeant massivement un système d'IA accessible via une API, un attaquant peut chercher à
        reconstituer une approximation du modèle sous-jacent, avec un risque de vol de propriété
        intellectuelle si ce modèle représente un investissement significatif.
      </p>

      <h2 style={s.h2}>Les attaques par manipulation d'entrée (adversarial inputs)</h2>
      <p>
        De légères modifications, souvent imperceptibles, d'une donnée d'entrée (image, texte) peuvent
        tromper un système d'IA et lui faire produire une classification ou une réponse erronée, exploitable
        selon le contexte d'usage du système.
      </p>

      <h2 style={s.h2}>La prompt injection</h2>
      <p>
        Pour les systèmes basés sur des instructions en langage naturel, la prompt injection consiste à
        détourner le comportement attendu du système en lui glissant des instructions cachées — un sujet
        suffisamment spécifique et fréquent pour faire l'objet de notre
        {' '}<Link to="/blog/prompt-injection-comprendre-proteger" style={s.link}>article dédié</Link>.
      </p>

      <h2 style={s.h2}>Le vol de données via l'infrastructure du système d'IA</h2>
      <p>
        Un système d'IA reste, techniquement, une application connectée à des données et parfois à d'autres
        systèmes internes. Une faille dans son infrastructure (API mal sécurisée, droits d'accès trop larges)
        peut donc être exploitée comme n'importe quelle autre porte d'entrée — voir notre article
        {' '}<Link to="/blog/securite-api-modeles-ia" style={s.link}>sur la sécurité des API et des modèles</Link>.
      </p>

      <h2 style={s.h2}>Comment prioriser ces risques pour votre entreprise</h2>
      <p>
        Toutes ces menaces ne se valent pas selon que vous développez vos propres systèmes d'IA ou que vous
        utilisez des outils tiers. Notre
        {' '}<Link to="/blog/evaluer-risques-ia-methode" style={s.link}>méthode d'évaluation des risques IA</Link>{' '}
        permet de les prioriser selon votre situation réelle, plutôt que de les traiter comme une liste
        générique à cocher.
      </p>
    </BlogArticleLayout>
  );
}

export default BlogArticleAttaquesSystemesIA;
